const { Promise, MutationObserver } = window;
export class AmpPlugin {
    constructor(Plugin) {
        this._Plugin = Plugin;
    }
    get Plugin() {
        return this._Plugin;
    }
    create(player, config, key) {
        const Plugin = this.Plugin;
        return (player, config, key) => {
            return new Promise(function(resolve, reject) {
                let plugin = new Plugin(player, config, key);

                function handleReady() {
                    player.removeEventListener('ready', handleReady, true);
                    plugin.init();
                }

                // AKAMAI initially creates a 'video' insead of an 'audio' HTML Element 
                // and replaces it later in it's lifecycle

                if (player.config.settings.medium === "audio" && player.mediaElement.tagName !== "AUDIO") {
                    let targetNode = player.container;


                    const OBSERVER_CONFIG = { attributes: false, childList: true, subtree: true };
                    const callback = (mutationsList, observer) => {
                        // Use traditional 'for loops' for IE 11
                        for (const mutation of mutationsList) {
                            if (mutation.type === 'childList') {
                                if (player.mediaElement.tagName === "AUDIO") {
                                    observer.disconnect();
                                    if (player.playState == null) {
                                        player.addEventListener('ready', handleReady, true);
                                    } else {
                                        plugin.init();
                                    }

                                    
                                }
                            }
                        }
                    };
                    const observer = new MutationObserver(callback);

                    observer.observe(targetNode, OBSERVER_CONFIG);


                } else {
                    if (player.playState == null) {
                        player.addEventListener('ready', handleReady, true);
                    } else {
                        plugin.init();
                    }
                    
                }
                resolve(plugin);
            });
        }
    }
}
class AmpPluginModule {
    constructor(player, config, key) {
        this._player = player;
        this._config = config;
        this._key = key;
    }
    get player() {
        return this._player;
    }
    get config() {
        return this._config;
    }
    get key() {
        return this._key;
    }
    init() {

    }
}
export class AmpPluginComponent extends AmpPluginModule {
    constructor(player, config, key) {
        super(player, config, key)
        this._el = null;
    }
    get el() {
        if (this._el == null) {
            this._el = document.createElement('div');

        }
        return this._el;
    }
    init() {
        super.init();
        this._el.classList.add('svp-amp-plugin');
    }
}
export { AmpPluginModule }